/*
Counter Up
 */


function fnCounterUp(i, oSection) {

    /*Get Data*/
    var $oSection = $(oSection),
        $oCounters = $('.stat-item .number', oSection),
        iCounter = 0,

        counterUp = window.counterUp["default"]; // import counterUp from "counterup2"

    fnCounter();

    $(window).on('scroll', function () {
        fnCounter();
    });

    function fnCounter() {
        if ($oSection.hasClass('in-view') && !($oSection.hasClass('counted'))) {  //in view
            if (iCounter === 0) {
                iCounter++;
                $oCounters.each(function (ignore, oCounter) {
                    counterUp(oCounter, {
                        duration: 100,
                        delay: 0.25
                    });
                    $oSection.addClass('counted');
                });
            }
        }
    };
}

